import * as React from 'react';
import { Checkbox, Avatar, Button } from '@mui/material';

interface UsersTableProps {
	headers: any[];
	users: any[];
	handleOwner: (user: any, index: number, checked: boolean) => Promise<boolean>;
	handleDeleteUser: (user: any) => void;
	isOwner?: boolean;
	// ... any other props you'd like to pass to the button
}

const UsersTable: React.FC<UsersTableProps> = ({
	headers,
	users,
	handleOwner,
	handleDeleteUser,
	isOwner,
}) => {
	const [showCheckBoxLoading, setShowCheckBoxLoading] = React.useState(false);

	const handleCheckbox =
		(user: any, index: number) =>
		async (event: React.ChangeEvent<HTMLInputElement>) => {
			if (showCheckBoxLoading) return;
			setShowCheckBoxLoading(true);
			await handleOwner(user, index, event.target.checked);
			setShowCheckBoxLoading(false);
		};

	const loggedUser = JSON.parse(
		localStorage.getItem('user_information') || '{}'
	);

	const stringToColor = (string: string) => {
		let hash = 0;
		let i;

		/* eslint-disable no-bitwise */
		for (i = 0; i < string.length; i += 1) {
			hash = string.charCodeAt(i) + ((hash << 5) - hash);
		}

		let color = '#';

		for (i = 0; i < 3; i += 1) {
			const value = (hash >> (i * 8)) & 0xff;
			color += `00${value.toString(16)}`.slice(-2);
		}
		/* eslint-enable no-bitwise */

		return `${color}90`;
	};

	const stringAvatar = (name: string) => {
		return {
			sx: {
				bgcolor: stringToColor(name),
			},
			children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
		};
	};

	const isUserActive = (user: any) => {
		if (user.status === 'Active') return true;
		return false;
	};

	React.useEffect(() => {}, [showCheckBoxLoading]);

	return (
		<div>
			<div
				className="
          grid grid-cols-12
          font-inter font-[600] text-[16px] tracking-[0.15px] leading-[24px] text-[#666666]
          border-b-[1px] border-[#E6E6E6] pb-[8px]
        "
			>
				{headers.map((header) => (
					<div className={`${header.colSpan}`}>{header.name}</div>
				))}
			</div>
			<div className="mt-[5px]">
				{users.map((user, index) => (
					<div
						className="
              grid grid-cols-12
              font-jost font-[400] text-[16px] tracking-[0.15px] leading-[24px] text-[#00000099]
              border-b-[1px] border-[#E6E6E6] pb-[8px] pt-[3px]
            "
					>
						<div className="col-span-1">
							<Checkbox
								className={`${
									showCheckBoxLoading && '!cursor-progress'
								}`}
								sx={{
									color: '#D8D8D8',
									'& .MuiSvgIcon-root': { fontSize: 24 },
								}}
								checked={user.siteOwnershipFlag}
								defaultChecked={user.siteOwnershipFlag}
								onChange={handleCheckbox(user, index)}
								disabled={!isOwner || loggedUser.id === user.id}
							/>
						</div>
						<div className="col-span-4 self-center flex flex-row gap-[10px] items-center ">
							<Avatar
								{...stringAvatar(
									`${
										isUserActive(user)
											? `${user.firstName} ${user.lastName}`
											: `${user.email
													.split('@')[0]
													.toUpperCase()} ${user.email
													.split('@')[1]
													.toUpperCase()}`
									}`
								)}
								className="!text-black !text-[16px] !font-[500]"
							/>
							{isUserActive(user) ? (
								<>
									{user.firstName} {user.lastName}
								</>
							) : (
								<>{user.email}</>
							)}
						</div>
						<div className="col-span-4 self-center relative">
							{user.email}
						</div>

						{isOwner && (
							<div className="col-span-3 self-center flex flex-row justify-between pl-[60px]">
								{isUserActive(user) ? (
									<div className="flex items-center">
										<div className="flex flex-row gap-[8px] items-center text-[#9EACB4] text-[14px] font-inter">
											<img
												src="assets/icons/check-icon-grey.svg"
												alt="check Icon"
												className="w-[18px] h-[14px]"
											/>
											Site access
										</div>
									</div>
								) : (
									<div className="flex items-center">
										<div className="flex flex-row gap-[8px] items-center text-[#FFA726] text-[14px] font-inter">
											<img
												src="assets/icons/warning-icon.svg"
												alt="check Icon"
												className="w-[18px] h-[14px]"
											/>
											{user.status}
										</div>
									</div>
								)}

								{isOwner && loggedUser.id !== user.id && (
									<button
										className="
                      !h-[40px] w-[40px] flex justify-center items-center 
                      px-[10px] py-[5px] rounded-[4px]
                      hover:shadow-sm hover:bg-[#0092c80a] 
                      focus:shadow-sm focus:bg-[#0092c80a] focus:outline-none
                    "
										onClick={() => handleDeleteUser(user)}
									>
										<img
											src="assets/icons/Trash.svg"
											alt="Drawer Icon"
											className="w-5 h-5 md:block hidden"
										/>
									</button>
								)}
							</div>
						)}

						{!isOwner && loggedUser.id === user.id && (
							<div className="col-span-3 self-center flex flex-row justify-end pl-[60px]">
								<button
									className="
                      !h-[40px] w-[40px] flex justify-center items-center 
                      px-[10px] py-[5px] rounded-[4px]
                      hover:shadow-sm hover:bg-[#0092c80a] 
                      focus:shadow-sm focus:bg-[#0092c80a] focus:outline-none
                    "
									onClick={() => handleDeleteUser(user)}
								>
									<img
										src="assets/icons/Trash.svg"
										alt="Drawer Icon"
										className="w-5 h-5 md:block hidden"
									/>
								</button>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default UsersTable;
